module.exports = __webpack_public_path__ + "static/img/img1.60822f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img1.jpg
// module id = UwWE
// module chunks = 0